module.exports = __webpack_public_path__ + "static/media/heart-rate.4fea3f0d.svg";